var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.125C11.2279 13.125 14.25 10.3548 14.25 6.9375C14.25 3.52024 11.2279 0.75 7.5 0.75C3.77208 0.75 0.75 3.52024 0.75 6.9375C0.75 8.43004 1.3265 9.79915 2.28652 10.8679C2.70164 11.3301 3.02269 11.9256 2.82462 12.5144C2.68738 12.9223 2.47425 13.2955 2.20184 13.617C2.31885 13.6379 2.4375 13.6543 2.55725 13.666C2.70282 13.6802 2.85059 13.6875 3 13.6875C3.96151 13.6875 4.85262 13.3859 5.58388 12.8722C6.1913 13.0367 6.8344 13.125 7.5 13.125Z",
    stroke: "#304359",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.061fe9739aa1c6f2fe0f3c4c2f44905f.svg";
export { ForwardRef as ReactComponent };